import * as qs from "query-string-for-all";
import * as React from "react";
import axios from "axios";
import CouncilIdentityBadge from "src/components/general/CouncilIdentity";
import Loading from "../general/Loading";
import { baseUrl } from "src/constants/ApiSettings";

interface IProps {
  councilId: number;
  name: string;
  ordinal: number;
  feature: null | boolean;
  logoOnly?: null | boolean; 
}

interface IState {
  image: null | string;
}

export default class CouncilHeaderWidget extends React.PureComponent<
  IProps,
  IState
> {
  public state = { image: null };

  public render() {
    axios
      .get(`${baseUrl}/logo?${qs.stringify({ council: this.props.councilId })}`)
      .then(res => {
        const image = res.data[0].path;
        this.setState({ image });
      })
      .catch(err => {
        // tslint:disable-next-line:no-console
        console.error(err);
      });

    if (!this.state.image) {
      return (
        <div className={((this.props.logoOnly === null) ? "flex flex-col w-1/4 items-center p-4" : "mb-2 w-1/2 block")}>
          <Loading />
        </div>
      );
    }

    if (this.props.logoOnly) {
      return (
        <div className="image-logo">
          <div className="w-full lg:w-1/2 xl:w-1/2 block">
            <img
              className="mb-2 councilImage sidenav-image" 
              src={require(`../../assets/${this.state.image}`)}
            />
          </div>
          <h3 className="my-2">{this.props.name}</h3>
        </div>
      );
    }

    return (
      <div className="c-council-identity flex flex-col justify-center">
        <div className="c-council-identity__media">
          <div className="c-council-identity__logo" 
            style={{
              backgroundImage: "url(" + require(`../../assets/${this.state.image}`) + ")"
            }}>
            <img
              className="sr-only"
              height={ 100 }
              width={ 100 }
              src={ require(`../../assets/${this.state.image}`) }
            />
          </div>
        </div>
        {( !this.props.logoOnly ) && (
          <div className="c-council-identity__content mt-4 justify-self-end justify-center">
            <CouncilIdentityBadge 
              name={ this.props.name }
              badge={ this.props.ordinal }
              modifier="justify-center"
            />
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CouncilsHeader/CouncilHeaderWidget.tsx